export const ENGLISH = 'en';
export const FRENCH = 'fr';
export const ITALIAN = 'it';
export const GERMAN = 'de';
export const SPANISH = 'sp';
export const POLISH = 'pl';
export const CHINESE = 'zh';
